/// <amd-module name="Artifacts/Connect/Constants" />

export const dismissedToolsKey = "ms.feed.feed-connect.dismissedTools";

export enum OperatingSystem {
  Windows = "Windows",
  Linux = "Linux",
  MacOs = "MacOs",
  Other = "allOS",
}

export enum Shell {
  PowerShell = "PowerShell",
  BashLinux = "BashLinux",
  BashMac = "BashMac",
  CmdExe = "CmdExe",
}
